import React, { useState } from "react";

export default function Contact() {
  const [sending, setSending] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    setSending(true);

    const form = new FormData(e.currentTarget);
    const name = form.get("name") || "";
    const email = form.get("email") || "";
    const subject = form.get("subject") || "Contact from website";
    const message = form.get("message") || "";

    // Use CRLF for best compatibility across email clients
    const body = `Name: ${name}\r\nEmail: ${email}\r\n\r\n${message}`;

    const mailto = `mailto:info@revytech.ca?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    // Open the mail client
    window.location.href = mailto;

    // Re-enable button shortly after navigation attempt
    setTimeout(() => setSending(false), 400);
  }

  return (
    <main className="py-10 ">
      <div className="container-x grid gap-6 lg:grid-cols-5">
        {/* Form */}
        <section className="lg:col-span-3 card p-5">
          <header className="mb-4">
            <p className="uppercase tracking-[0.2em] text-[#D4FF00] font-extrabold text-xs">Contact</p>
            <h1 className="text-3xl font-extrabold mt-1">Let’s talk.</h1>
            <p className="text-neutral-400 mt-1 text-sm">
              Questions about bookings, parties, or gear? Send us a note.
            </p>
          </header>

          <form onSubmit={handleSubmit} className="grid gap-3">
            <div className="grid sm:grid-cols-2 gap-3">
              <label className="block">
                <span className="block text-sm font-semibold mb-1">Name</span>
                <input
                  name="name"
                  required
                  className="w-full bg-[#0a0a0a] border border-[#1a1a1a] rounded-xl px-3 py-2 outline-none focus:ring-2 focus:ring-[#D4FF00]/60"
                  placeholder="Alex Jensen"
                />
              </label>
              <label className="block">
                <span className="block text-sm font-semibold mb-1">Email</span>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full bg-[#0a0a0a] border border-[#1a1a1a] rounded-xl px-3 py-2 outline-none focus:ring-2 focus:ring-[#D4FF00]/60"
                  placeholder="you@example.com"
                />
              </label>
            </div>

            <label className="block">
              <span className="block text-sm font-semibold mb-1">Subject</span>
              <input
                name="subject"
                className="w-full bg-[#0a0a0a] border border-[#1a1a1a] rounded-xl px-3 py-2 outline-none focus:ring-2 focus:ring-[#D4FF00]/60"
                placeholder="Birthday party booking"
              />
            </label>

            <label className="block">
              <span className="block text-sm font-semibold mb-1">Message</span>
              <textarea
                name="message"
                required
                rows={6}
                className="w-full bg-[#0a0a0a] border border-[#1a1a1a] rounded-xl px-3 py-2 outline-none focus:ring-2 focus:ring-[#D4FF00]/60"
                placeholder="Tell us your date, times, and how many players."
              />
            </label>

            <div className="flex items-center gap-3">
              <button
                type="submit"
                disabled={sending}
                className="btn btn-accent disabled:opacity-60"
              >
                {sending ? "Opening mail…" : "Send"}
              </button>
              <a
                href="mailto:info@revytech.ca"
                className="btn"
              >
                Email directly
              </a>
            </div>
          </form>
        </section>

        {/* Info & Map */}
        <aside className="lg:col-span-2 space-y-4">
          <div className="card p-5">
            <h3 className="font-bold mb-2 text-accent">Visit</h3>
            <p className="text-md">103 2 St E Downstairs, Revelstoke, BC V0E 2S0, Canada</p>
            <p className="text-neutral-400 text-sm">Open Mon - Fri • 11:00am – 5:00pm</p>
          </div>

          <div className="card p-5">
            <h3 className="font-bold mb-2 text-accent">Contact</h3>
            <p>
              <a className="hover:text-accent transition:hover duration-100 ease-in" href="mailto:info@revytech.ca">
                info@revytech.ca
              </a>
            </p>
            <p>
              <a className="hover:text-accent transition:hover duration-100 ease-in" href="tel:+12505551234">
                +1 (250) 555-1234
              </a>
            </p>
          </div>

          <div className="card overflow-hidden">
            {/* Simple map embed (replace q= with your exact address for precision) */}
            <iframe
              title="Revelstoke Gaming Cafe map"
              className="w-full h-72 border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d584.6151091514822!2d-118.19573655942081!3d50.99777087489835!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x537937bfde647ce1%3A0x864002933cfd4e9b!2sRevyTech!5e1!3m2!1sen!2sus!4v1756684861549!5m2!1sen!2sus"/>
          </div>
        </aside>
      </div>
    </main>
  );
}
